import React__default, { forwardRef } from 'react';
import TextInputInnerVisualSlot from '../TextInput/TextInputInnerVisualSlot.js';
import AutocompleteInputWrapper from './_AutocompleteInputWrapper.js';
import { AutocompleteUnstyledInput } from './_AutocompleteUnstyledInput.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

/**  */
const AutocompleteInput = /*#__PURE__*/forwardRef(({
  leadingVisual: LeadingVisual,
  placeholder,
  loading,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const showLeadingLoadingIndicator = loading;
  return /*#__PURE__*/React__default.createElement(AutocompleteInputWrapper, {
    hasLeadingVisual: Boolean(LeadingVisual || showLeadingLoadingIndicator),
    "aria-live": "polite",
    "aria-busy": Boolean(loading)
  }, /*#__PURE__*/React__default.createElement(TextInputInnerVisualSlot, {
    visualPosition: "leading",
    showLoadingIndicator: showLeadingLoadingIndicator,
    hasLoadingIndicator: typeof loading === 'boolean'
  }, typeof LeadingVisual === 'function' ? /*#__PURE__*/React__default.createElement(LeadingVisual, null) : LeadingVisual), /*#__PURE__*/React__default.createElement(AutocompleteUnstyledInput, {
    ref: innerRef,
    placeholder: placeholder
  }));
});
AutocompleteInput.displayName = 'CustomComboboxInput';
var AutocompleteInput$1 = AutocompleteInput;

export { AutocompleteInput$1 as default };
